module.exports = __webpack_public_path__ + "static/media/Florida Rural Water Association Logo.6f383711.jpeg";